import React, {createContext, useContext, useEffect, useState} from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {jwtDecode} from "jwt-decode";
import Parse from '../api/config';

const AuthContext = createContext({
    user: null,
    parseUser: null,
    signIn: () => {},
    signOut: () => {}
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [parseUser, setParseUser] = useState(null);

    useEffect(() => {
        // Check if there is a user stored in localStorage when the component mounts
        const storedUser = localStorage.getItem('user');
        const storedParseUser = localStorage.getItem('parseUser');
        
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        
        if (storedParseUser) {
            // For Parse, we don't parse the JSON - we check for current user
            const currentUser = Parse.User.current();
            if (currentUser) {
                setParseUser(currentUser);
            }
        }
    }, []);

    const signIn = async (response) => {
        console.log('Login Success:', response);
        if (response.credential) {
            const userPayload = jwtDecode(response.credential);
            const userData = {
                name: userPayload.name,
                email: userPayload.email,
                picture: userPayload.picture
            };
            
            try {
                // Authenticate with Parse using Google credentials
                const parseUser = await Parse.User.logInWith('google', {
                    authData: {
                        id: userPayload.sub,
                        id_token: response.credential
                    }
                });
                
                // Update Parse user with profile data if needed
                if (!parseUser.get('name')) {
                    parseUser.set('name', userPayload.name);
                    parseUser.set('email', userPayload.email);
                    await parseUser.save();
                }
                
                // Store both regular user data and Parse user
                setUser(userData);
                setParseUser(parseUser);
                
                // Save to localStorage
                localStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem('parseUser', 'true'); // Just a flag, we'll use Parse.User.current()
            } catch (error) {
                console.error('Parse authentication error:', error);
            }
        }
    };

    const signOut = async () => {
        try {
            // Log out from Parse
            await Parse.User.logOut();
            console.log('Logged out from Parse');
            
            // Clear state and localStorage
            setUser(null);
            setParseUser(null);
            localStorage.removeItem('user');
            localStorage.removeItem('parseUser');
        } catch (error) {
            console.error('Error during sign out:', error);
        }
    };

    return (
        <AuthContext.Provider value={{ user, parseUser, signIn, signOut }}>
            {children}
        </AuthContext.Provider>
    );
};

const clientId = "273944291151-i9cmblf29188vhb7csmggrnikp9i6j29.apps.googleusercontent.com";

export const AuthProviderWrapper = ({ children }) => (
    <GoogleOAuthProvider clientId={clientId}>
        <AuthProvider>
            {children}
        </AuthProvider>
    </GoogleOAuthProvider>
);
